import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize only if config is present (prevents crash if using Supabase only)
const app = firebaseConfig.apiKey ? initializeApp(firebaseConfig) : undefined;
export const auth = app ? getAuth(app) : undefined;

// Connect to Auth Emulator in development mode OR when VITE_USE_EMULATORS is set
// This must happen before any auth operations
// - DEV mode: automatically connects (Vite dev server)
// - Built for emulators: set VITE_USE_EMULATORS=true before build
const useEmulators = import.meta.env.DEV || import.meta.env.VITE_USE_EMULATORS === 'true';

if (auth && useEmulators) {
    try {
        console.log('[Firebase] Connecting to Auth Emulator at http://127.0.0.1:9099');
        connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    } catch (error) {
        console.error('[Firebase] Failed to connect to Auth Emulator:', error);
    }
}

export const db = undefined; // Placeholder for Firestore if needed in frontend
